/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NoData from '@/components/NoData';
import GoodsItem from './GoodsItem';
import { GetGoodsList } from '@/api/mall';
import BScroll from '@/components/Bscroll';
import BottomLine from '@/components/BottomLine';
import LoadLine from './LoadLine';
import NoDataImg from '@/resources/images/mall/noOrder.png';
export default {
  props: {
    keywords: String,
    goodsCategoryId: String,
    direction: {
      type: String,
      "default": 'column'
    }
  },
  data: function data() {
    return {
      pageSize: 10,
      pageNo: 1,
      noData: false,
      goodsList: [],
      noDataDesc: '暂无商品',
      NoDataImg: NoDataImg,
      loadStatus: 1 //加载状态 0:正在加载中  1:上拉加载更多  2:无更多数据

    };
  },
  components: {
    GoodsItem: GoodsItem,
    NoData: NoData,
    BScroll: BScroll,
    LoadLine: LoadLine
  },
  computed: {},
  created: function created() {
    this.getGoodsListAjax();
  },
  mounted: function mounted() {},
  watch: {
    keywords: function keywords(val) {
      this.pageNo = 1;
      this.getGoodsListAjax();
    }
  },
  methods: {
    scrollToEndEvnet: function scrollToEndEvnet() {
      if (this.loadStatus == 2) {
        return;
      }

      this.pageNo++;
      this.getGoodsListAjax(); //第N次加载完成列表数据
    },
    getGoodsListAjax: function getGoodsListAjax() {
      var _this = this;

      this.loadStatus = 0;
      var param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };

      if (this.keywords) {
        param.keyWord = this.keywords;
      }

      if (this.goodsCategoryId) {
        param.goodsCategoryId = this.goodsCategoryId;
      }

      if (this.pageNo == 1) {
        this.goodsList = [];
      }

      console.log(param);
      GetGoodsList(param).then(function (data) {
        if (data.totalPage == data.currentPage) {
          _this.loadStatus = 2;
        }

        _this.goodsList = [].concat(_toConsumableArray(_this.goodsList), _toConsumableArray(data.dataSource));

        if (!_this.goodsList || _this.goodsList.length == 0) {
          _this.noData = true;
        } else {
          _this.noData = false;
        }
      });
    }
  }
};